// extracted by mini-css-extract-plugin
export default {"button":"Button_button__LJEKJ","primary":"Button_primary__n7R6v","secondary":"Button_secondary__7Il-0","tertiary":"Button_tertiary__uhHYI"};